/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

//file is only loaded once, not for each instance of block.

/* eslint-disable no-console */
document.addEventListener('DOMContentLoaded', () => {
    //get block instance
    
});
// listen to event regionChange on body
document.addEventListener('regionChange', function (e) {
    // show or hide block based on region. need access to the blocks attributes for testing/validation
    document.querySelectorAll('.wp-block-create-block-filter-group-block').forEach(blockEl => {
        const blockId = blockEl.getAttribute('data-block-id');
        const regionVal = blockEl.getAttribute('data-blockattribute-val');
        const conditionVal = blockEl.getAttribute('data-blockattribute-cond');
        let showBlock = false;
        
        if(regionVal != null){
            switch(conditionVal){
                case 'show_if_value_match':
                    showBlock = (regionVal == e.detail.region);
                    //if regionVal contains e.detail.region show block
                    //showBlock = (regionVal.includes(e.detail.region));
                    break;
                case 'show_if_value_notmatch':
                    showBlock = (regionVal != e.detail.region);
                    //showBlock = !(regionVal.includes(e.detail.region));
                    break;
            }
        }
        //if(e.detail.region == 'regionROW') showBlock = true;//NO this is "rest of the world"
        if (showBlock) {
            blockEl.style.display = 'block';
        } else {
            blockEl.style.display = 'none';
        }
        //get parent div and if has class .wp-block-column hide or show based on showBlock
        const parentDiv = blockEl.closest('.wp-block-column');
        if (parentDiv) {
            parentDiv.style.display = showBlock ? 'block' : 'none';
        }
    });
});
/* eslint-enable no-console */
